import React from "react";
import { Row, Col, InputNumber, Switch } from "antd";

const SosConfig = ({ fields, setField }) => (
  <div className="pt-2">
    <Row gutter={16} className="mb-2">
      <Col span={10} />
      <Col span={4} className="text-center">
        <span className="text-muted small">偵測啟動</span>
      </Col>
      <Col span={10}>
        <span className="text-muted small">冷卻時間</span>
      </Col>
    </Row>
    <Row gutter={16} className="align-items-center">
      <Col span={10}>
        <label className="font-weight-bold">SOS 警報</label>
        <div className="text-muted small">同一裝置再次觸發的最短間隔</div>
      </Col>
      <Col span={4} className="text-center">
        <Switch
          checked={fields.sos_enabled}
          onChange={(v) => setField("sos_enabled", v)}
        />
      </Col>
      <Col span={10}>
        <InputNumber
          style={{ width: "100%" }}
          min={60}
          max={86400}
          step={60}
          value={fields.sos_cooldown_seconds}
          onChange={(v) => setField("sos_cooldown_seconds", v)}
          addonAfter="秒"
        />
      </Col>
    </Row>
  </div>
);

export default SosConfig;
